<h2 mat-dialog-title><mat-icon class="icon-20" >delete</mat-icon> Remove User: {{data.user.email}} ({{data.user.email}})</h2>
<div mat-dialog-content>Are you sure?<br /><br /></div>
<div mat-dialog-actions>
  <button mat-raised-button color="warn" mat-dialog-close="Yes" aria-label="Yes">Yes</button>
  <button mat-button mat-dialog-close="No" aria-label="No">No</button>
</div>
